module.exports = __webpack_public_path__ + "img/hd2.94eb137c.png";